import { getRem } from './../../core';
import { INPUT_SIZES } from './../../input';

export const inlineInputContainerSize = {
  [INPUT_SIZES.LARGE]: getRem('40px'),
  [INPUT_SIZES.SMALL]: getRem('32px'),
  [INPUT_SIZES.STANDARD]: getRem('36px'),
};
